import { createReducer, on } from '@ngrx/store';
import { deleteFamilyTreeFailure, deleteFamilyTreeSuccess, getFamilyTreeFailure, getFamilyTreeRequest, getFamilyTreeSuccess } from './actions';
import { initialState } from './state';

export const familyTreeReducer = createReducer(
  initialState,
  on(getFamilyTreeRequest, (state, action) => {
    return {
      ...state,
      loader: action.loader ?? true,
    };
  }),
  on(getFamilyTreeSuccess, (state, { payload }) => ({ ...state, familyTrees: payload, loader: false, initialLoad: false })),
  on(getFamilyTreeFailure, (state, { error }) => ({ ...state, loader: false, error })),
  on(deleteFamilyTreeSuccess, (state, { familyTreeId }) => {
    const familyTrees = state.familyTrees.filter((item) => item.id !== familyTreeId);
    return { ...state, familyTrees };
  }),
  on(deleteFamilyTreeFailure, (state, { error }) => ({ ...state, error }))
);
